module.exports = __webpack_public_path__ + "media/images/icon/ico_gold-3aaf40ff266f04b6e707e9c8a8646880.svg";